import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {

  },
  mutations: {

  },
  actions: {
    async fetchUsers({ commit, state }) {

      commit('RESET_STATE');

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/users/');
        commit('SET_DATA', {data:response.data.data});
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    users: state => state.data,
    usersLoading: state => state.loading,
    usersError: state => state.error,
    usersLoaded: state => state.loaded,
  }
})